import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@components/table';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API } from '@awp/constants';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { sortDataTablesByNumericThenAlpha, sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { format as formatDate } from 'date-fns';

const ObservationValidationHistoryTable = ({ idx, requestDTO, displayDays, collectionIntervalMins }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  /* useEffect(() => {
		const handleResize = debounce(() => {
			setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
		}, 100);

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}); */

  const TableColumns = useMemo(
    () => [
      {
        Header: 'Log Entry',
        accessor: 'AppCreateTimestampMilliseconds',
        //sortType: sortDataTablesByNumericThenAlpha, // do not imp this line
        Cell: (a) => {
          return a.value ? formatDate(a.value, 'yyyy-MM-dd HH:mm') : '';
        },
      },
      {
        Header: 'Timestamp',
        accessor: 'CollectionTimestampMilliseconds',
        //sortType: sortDataTablesByNumericThenAlpha, // do not imp this line
        Cell: (a) => {
          return a.value ? formatDate(a.value, 'yyyy-MM-dd HH:mm') : '';
        },
      },
      {
        Header: 'Change',
        accessor: 'ConfidenceChange',
        Cell: (p) => {
          let confidences = p.value.split('_');
          if (isValueEmpty(confidences) || confidences.length < 2) return p.value;
          return [
            <div key={`tbl_log_confidenceChange_${idx}`}>
              <span>{confidences[0]}</span>&nbsp;<span style={{ color: 'red' }}>&rarr;</span>&nbsp;
              <span>{confidences[1]}</span>
            </div>,
          ];
        },
      },
      {
        Header: 'ChangeBy',
        accessor: 'AppCreateUserId',
        //className:"col-1",
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Reason For Change',
        accessor: 'Reason',
        //className:"col-1",
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Comments',
        accessor: 'ManualComment',
        //className:"col-1",
        show: isMedium,
        sortType: sortByNumericThenAlpha,
        Cell: (c) => {
          let cm = c.value + '';
          if (isValueEmpty(cm)) return '';
          if (cm.length > 10) {
            let cm_large = cm.length > 2000 ? cm.substring(0, 2000) : cm;
            return [
              <div key={`val_log_col_comments_${idx}`} title={cm_large}>
                {cm.substring(0, 10) + '...'}
              </div>,
            ];
          }
          return cm;
        },
      },
      {
        Header: 'ObservationValidationHistoryId',
        accessor: 'ObservationValidationHistoryId',
        //className:"col-1",
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
    ],
    [isMedium],
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Find current values of search and filter

  useEffect(() => {
    fetchData(); //children function of interest
  }, [requestDTO, displayDays, collectionIntervalMins]);

  const fetchData = useCallback(() => {
    setLoading(true);
    if (
      isValueEmpty(requestDTO) ||
      //||isValueEmpty(requestDTO.From)
      isValueEmpty(requestDTO.To) ||
      isValueEmpty(requestDTO.ObservationTypeId) ||
      isValueEmpty(requestDTO.SensorPlacementId)
    ) {
      setLoading(false);
      return;
    }
    let url = REST_API.OBSERVATIONS_VALIDATION_HIST;
    if (!isValueEmpty(displayDays) && !isValueEmpty(collectionIntervalMins)) {
      url += 'monitor/';
      url += displayDays + '/' + collectionIntervalMins + '/';
      url += '?To=' + (requestDTO.To || '');
    } else {
      url += '?From=' + (requestDTO.From || '');
      url += '&To=' + (requestDTO.To || '');
    }
    url += '&ObservationTypeId=' + (requestDTO.ObservationTypeId || '');
    url += '&SensorPlacementId=' + (requestDTO.SensorPlacementId || '');
    url += '&SensorLayerNumber=' + (requestDTO.SensorLayerNumber || '');
    console.log(url);
    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      });
  }, [requestDTO]);

  return (
    <Table
      id={idx}
      columns={TableColumns}
      data={data}
      fetchData={() => {}}
      loading={loading}
      search={[]}
      filters={[]}
      dataTriggers={[]}
      hiddenColumns={['ObservationValidationHistoryId']}
      defaultSortBy={['AppCreateTimestampMilliseconds']}
      defaultDesc={true}
      defaultPageSize={5} //must be one of [5, 10, 25, 50, 100]
    />
  );
};
ObservationValidationHistoryTable.propTypes = {
  idx: PropTypes.string,
  requestDTO: PropTypes.object,
};
export default ObservationValidationHistoryTable;
